import React from 'react';

import { Box, Tooltip } from '@material-ui/core';
import BatteryStdIcon from '@material-ui/icons/BatteryStd';
import NetworkWifiIcon from '@material-ui/icons/NetworkWifi';
import PropTypes from 'prop-types';

export default function TankWithSensorIcon({
  colorTank,
  colorSensor,
  background,
  size,
  tooltip,
}) {
  return (
    <Tooltip title={tooltip}>
      <span style={{ display: 'inline-block' }}>
        <Box
          position="relative"
          display="inline-block"
          width={size}
          height={size}
          style={{ verticalAlign: 'middle' }}
        >
          <BatteryStdIcon
            style={{
              fontSize: size,
              color: colorTank,
              transform: 'scaleX(1.5)',
            }}
          />

          <Box
            style={{
              position: 'absolute',
              bottom: 0,
              right: 0,
              width: size / 2,
              height: size / 2,
              backgroundColor: background,
              borderRadius: '50%',
              zIndex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <NetworkWifiIcon
              style={{
                fontSize: size / 2 - 2,
                color: colorSensor,
                zIndex: 2,
              }}
            />
          </Box>
        </Box>
      </span>
    </Tooltip>
  );
}

TankWithSensorIcon.propTypes = {
  colorTank: PropTypes.string.isRequired,
  colorSensor: PropTypes.string.isRequired,
  background: PropTypes.string.isRequired,
  size: PropTypes.number,
  tooltip: PropTypes.string,
};

TankWithSensorIcon.defaultProps = {
  size: 22,
  tooltip: '',
};
